function faqFilter(term_id) {
    $('.m__accordion[data-term]').addClass('hide');

    if(term_id){
        $('.m__accordion[data-term='+ term_id +']').removeClass('hide');
        $(window).scrollTop($(window).scrollTop()+1);
    } else {
        $('.m__accordion[data-term]').removeClass('hide');
    }
} 

$(document).on("click", 'body.page-template-page-faqs .c__filter__links li[data-term]', function(e) { 
    e.preventDefault(); 

    $('.c__filter__links li').removeClass('active');
    $(this).addClass('active');

    var term_id = $(this).attr('data-term');

    faqFilter(term_id);
});

$(document).on("keydown", 'body.page-template-page-faqs .c__filter__links li[data-term]', function(e) {
    if (e.key === "Enter" || e.keyCode === 13) {
        $(this).trigger("click");
    }
});

$(document).on("change", 'body.page-template-page-faqs select[name="faq-filter"]', function(e) { 
    e.preventDefault(); 
    var term_id = $(this).val();
    faqFilter(term_id);
});